import { Input, Button } from 'antd';
import ResizableHeaderCell from './ResizableHeaderCell';

/**
 * Bits the browse tables share — the entity table on the homepage and the
 * connection table on Browse Edges. Pure helpers only: each page keeps its own
 * rows, columns and query state.
 */

// Table header cell override that adds the resize handle.
export const TABLE_COMPONENTS = { header: { cell: ResizableHeaderCell } };

// Sort key comparison where a missing value (null) always sorts last,
// whichever direction the column is sorted in.
export function compareNullsLast(a, b) {
    if (a === null && b === null) return 0;
    if (a === null) return 1;
    if (b === null) return -1;
    return typeof a === 'number' && typeof b === 'number' ? a - b : String(a).localeCompare(String(b));
}

// antd filterDropdown for a free-text "contains" search on a column.
export function textSearchDropdown(placeholder) {
    return ({ selectedKeys, setSelectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
            <Input
                autoFocus
                allowClear
                placeholder={placeholder}
                value={selectedKeys[0]}
                onChange={e => {
                    setSelectedKeys(e.target.value ? [e.target.value] : []);
                    confirm({ closeDropdown: false });
                }}
                onPressEnter={() => confirm()}
                style={{ width: 200, marginBottom: 8, display: 'block' }}
            />
            <Button size="small" onClick={() => { clearFilters?.(); confirm(); }}>Reset</Button>
        </div>
    );
}

// Per-viewer table preferences live in localStorage: a browser-local
// convenience, like the theme. Reads fall back when storage is blocked or
// holds something unreadable; writes fail silently and keep the in-memory value.
export function loadStoredJson(key, fallback) {
    try {
        const value = JSON.parse(localStorage.getItem(key));
        return value ?? fallback;
    } catch {
        return fallback;
    }
}

export function saveStoredJson(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* storage blocked — keep in memory */ }
}
